import { Component, ContentChild, Input, OnChanges } from '@angular/core';
import { ValidationErrors } from '@angular/forms';

import { VtmnPlayIconTypeEnum } from '~/component/vtmn-play-icon/enums/vtmn-play-icon-type.enum';
import { FormControlService } from '~/core/services/form/form-control.service';

@Component({
  selector: 'app-form-input-group',
  templateUrl: './input-group.component.html',
  styleUrls: ['./input-group.component.scss'],
})
export class FormInputGroupComponent implements OnChanges {
  @ContentChild('content') public content;
  @ContentChild('label') public customLabel?;

  @Input() public errorKey?: string;
  @Input() public errors?: ValidationErrors | string[];
  @Input() public isHiddenLabel? = false;
  @Input() public label?: string;
  @Input() public tips?: string;

  public readonly iconType = VtmnPlayIconTypeEnum;

  public codeIsValid = false;

  constructor(private readonly formControlService: FormControlService) {}

  public ngOnChanges(changes): void {
    if (changes.errors && this.content?.hasOwnProperty.call('hasError')) {
      if (this.errors && Array.isArray(this.errors)) {
        this.content.hasError = this.errors?.length;
        return;
      }

      this.content.hasError = this.errors && Object.keys(this.errors).length;
    }

    if (this.errors && 'success' in this.errors) {
      this.codeIsValid = true;
      return;
    }

    this.codeIsValid = false;
  }

  public get errorsId(): string {
    return this.content?.errorsId;
  }

  public get formattedErrors(): string[] {
    if (Array.isArray(this.errors)) {
      return this.errors;
    }

    return this.formControlService.getFormattedErrors(
      this.errors,
      this.errorKey
    );
  }

  public get formattedLabel(): string {
    if (!this.label) {
      return '';
    }

    return this.content?.required ? `${this.label}*` : this.label;
  }

  public get hasTips(): boolean {
    return !!this.tips;
  }

  public get icon(): VtmnPlayIconTypeEnum {
    return this.codeIsValid ? this.iconType.Check : this.iconType.WarningError;
  }
  public get id(): string {
    return this.content?.id;
  }
}
